import { MaterialUICore, TextField } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const PersonalizedTextField = styled(TextField)({
  flex: 1,
});
